export default {
  filterBtn: `Filter`,
  editBtn: `Edit Filters`,
  pageCount: totalData => `${totalData} products`,
  sortBy: `Sort by`,
  unlocalisedBtn: `Add postcode`,
  unlocalisedText: ` to see what’s available`,
  localisedText: `Collection and delivery for `,
  availabilityErrorMessage: `Sorry, we’re experiencing some difficulties with our service right now. Please refresh to try again`
}
